/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Freight_InInputs */

const en_setup_freight_in = /** @type {(inputs: Setup_Freight_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freight in`)
};

/**
* | output |
* | --- |
* | "Freight in" |
*
* @param {Setup_Freight_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_freight_in = /** @type {((inputs?: Setup_Freight_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Freight_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_freight_in(inputs)
});